import { View, Text, Dimensions, Image } from "react-native";
import React from "react";
import {
  femaleColor,
  gray,
  green,
  maleColor,
  primary,
  success,
  white,
} from "../../colors";
import { testChildren, tests, tutorial } from "../../imports";
import translate from "../../functions/translate";
import MyText from "../../components/custom/MyText";
import { useDispatch, useSelector } from "react-redux";
import { useIsFocused, useNavigation } from "@react-navigation/native";
import {
  changeHeaderColor,
  hideBackButton,
} from "../../redux/header/headerAction";
import { useEffect } from "react";
import { useState } from "react";
import SelectChildrenMini from "../../components/custom/SelectChildrenMini";
import TestItem from "../../components/test/TestItem";
import Header from "../../components/header/Header";
import { ScrollView } from "react-native-gesture-handler";
import MyButton from "../../components/custom/MyButton";

export default function TestStartInfo({ route }) {
  const { details, type, userDetails } = route.params;
  const navigation = useNavigation();
  const dispatch = useDispatch();
  const main = useSelector((store) => store.main);
  const [selectedChild, setChild] = useState({ gender: "male", name: "ahmad" });

  const isFocused = useIsFocused();
  useEffect(() => {
    if (isFocused) {
      dispatch(changeHeaderColor("#F7F7F7"));
      dispatch(hideBackButton());
    }
  }, [isFocused]);
  useEffect(() => {}, []);
  return (
    <View style={{ flex: 1, alignItems: "center" }}>
      <View style={{ width: "100%" }}>
        <Header notOpenDrawer={true} />
      </View>
      <ScrollView style={{ flex: 1 }}>
        <View
          style={{
            width: "100%",
            alignItems: "center",
            flex: 1,
            paddingBottom: 100,
          }}
        >
          <View style={{ alignItems: "center" }}>
            <View
              style={{
                height: Dimensions.get("window").height,
                marginTop: -1 * Dimensions.get("window").height,
                backgroundColor: "#F7F7F7",
                width: "100%",
              }}
            ></View>
            <View style={{ alignItems: "center" }}>
              <View style={{ backgroundColor: "#F7F7F7" }}>
                <View
                  style={{
                    backgroundColor: "#F7F7F7",
                    justifyContent: "center",
                    alignItems: "center",
                    zIndex: 10,
                    width: Dimensions.get("screen").width,
                    minHeight: 200,
                    flexDirection: "row",
                    paddingHorizontal: 10,
                  }}
                >
                  <View style={{ flex: 1 }}>
                    <Image
                      source={testChildren}
                      style={{ width: "100%", height: 207 }}
                      resizeMode="contain"
                    />
                  </View>
                </View>
              </View>
            </View>
          </View>
          <View></View>
          <Text
            style={{
              marginVertical: 10,
              fontSize: 20,
              fontWeight: "bold",
              color: primary,
            }}
          >
            {`آزمون ${type}`}
          </Text>
          {type === "ASQ3" && (
            <Text
              style={{
                marginVertical: 10,
                fontSize: 16,

                color: gray,
              }}
            >
              {translate(route.params.part)}
            </Text>
          )}
          <View style={{ width: "95%" }}>
            <Text style={{ marginVertical: 7 }}>
              {translate(
                "Dear parent, please answer the questions accurately and correctly."
              )}
            </Text>
            <Text style={{ marginVertical: 7 }}>
              {translate(
                "Your honest and accurate answers will make the result of the test more correct and accurate."
              )}
            </Text>
            <Text style={{ marginVertical: 7, color: primary }}>
              {translate(
                "If you are confused about a question, there is a video or text to explain the question for most of the questions."
              )}
            </Text>
          </View>
        </View>
      </ScrollView>
      <View style={{ width: "90%" }}>
        <MyButton
          onPress={() =>
            navigation.navigate("TestQuestion", {
              test: details.question,
              questionNumber: 1,
              answer: [],
              type: type,
              part: route.params.part,
              userDetails: userDetails,
            })
          }
          text={translate("start doing test")}
          style={{
            backgroundColor: green,
            paddingVertical: 15,
            marginBottom: 30,
          }}
        />
      </View>
    </View>
  );
}
